import { SnackbarProvider } from 'notistack';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Navbar from "../../../components/Navbar";
import React from "react";
import moment from "moment";
import style from "./IDFA.module.css";
import Logo from './logo.png';
import { jsPDF } from "jspdf"; // Importa a biblioteca jsPDF
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";

const IDFA = () => {

    // Estados do componente
    const { id } = useParams();
    const [navioslist, setNaviosList] = useState([]);
    const [periodo, setPeriodo] = useState([]);
    const [qtdeManifestadaTotal, setQtdeManifestadaTotal] = useState(0);
    const [operacoes, setOperacoes] = useState([]);
    const [atracacao, setAtracacao] = useState("");
    const [nomeNavio, setNomeNavio] = useState("");
    const [rap, setRap] = useState("");
    const [nomeBerco, setNomeBerco] = useState("");
    const [eta, setEta] = useState("");
    const [cargaData, setCargaData] = useState([]);
    const [idfaData, setIdfaData] = useState([]);  // Adicionado para o estado do IDFA
    const [faTonValues, setFaTonValues] = useState([]);
    const [faPercentValues, setFaPercentValues] = useState([]);

    const navigate = useNavigate();

    // Funções que estavam faltando
    const getPeriodo = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/operacao/gerais/${id}`).then((response) => {
            setPeriodo(response.data);
        });
    };

    const getOp = () => {
        Axios.get('https://operacao.setlogistica.com.br/api/relatorios/operacoes').then((response) => {
            setNaviosList(response.data);
        });
    };

    const DadosDashboard = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/periodo/dashboard/${id}`)
            .then(function (res) {
                // Adicionar lógica para os dados do dashboard se necessário
            });
    };

    const VerificaParalisacao = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/verifica/paralisacao/${id}`)
            .then(function (res) {
                // Adicionar lógica para verificar a paralisação
            });
    };

    const getIDFA = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/relatorio/idfa/navio/${id}`)
            .then((response) => {
                setIdfaData(response.data);  // Usando setIdfaData aqui
                if (response.data.length > 0) {
                    setNomeNavio(response.data[0].NOME_NAVIO);
                    setRap(response.data[0].RAP);
                    setNomeBerco(response.data[0].NOME_BERCO);
                    setEta(response.data[0].ETA);
                }
            })
            .catch((err) => {
                console.error("Erro ao buscar dados do IDFA:", err);
            });
    };

    const getCargaData = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/relatorio/idfa/carga/${id}`)
            .then((response) => {
                setCargaData(response.data);
            })
            .catch((err) => {
                console.error("Erro ao buscar dados da carga:", err);
            });
    };

    useEffect(() => {
        getPeriodo();
        getOp();
        getIDFA();
        getCargaData();
        DadosDashboard();
        VerificaParalisacao();
    }, []);

// Função para exportar o PDF com o CSS aplicado
// Função para converter a imagem em base64
const getBase64ImageFromUrl = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous'); // Para evitar problemas de CORS
        img.src = url;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/png');
            resolve(dataURL);
        };
        img.onerror = (error) => {
            reject(error);
        };
    });
};

function formatCNPJ(cnpj) {
    if (!cnpj || cnpj.length !== 14) return cnpj; // Verifica se o CNPJ tem 14 dígitos
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

const exportToPDF = async () => {
    const doc = new jsPDF('landscape');

    // Converter o logo para base64
    const logoBase64 = await getBase64ImageFromUrl(Logo);

    // Adicionar o logo no canto superior esquerdo
    const imgWidth = 45; // Largura do logo
    const imgHeight = 15; // Altura do logo
    doc.addImage(logoBase64, 'PNG', 10, 10, imgWidth, imgHeight); // Posição e dimensões da imagem

    // Adicionar o título centralizado no topo
    const pageWidth = doc.internal.pageSize.getWidth(); // Largura total da página
    const title = "IDFA - IDENTIFICAÇÃO DE FALTAS/ACRESCIMOS";
    const titleXPosition = (pageWidth - doc.getTextWidth(title)) / 2; // Calcula a posição para centralizar o texto
    
    doc.setFontSize(16); // Define o tamanho da fonte
    doc.setFont("helvetica", "bold"); // Define a fonte e o estilo em negrito
    doc.text(title, titleXPosition, 20); // Texto centralizado e em negrito

    // Adicionar a data no canto superior direito
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal"); // Volta a fonte para o estilo normal
    const dateText = `${moment().format('DD/MM/YYYY')}`;
    const dateXPosition = pageWidth - doc.getTextWidth(dateText) - 5; // Alinha à direita com 10px de margem
    doc.text(dateText, dateXPosition, 20); // Texto alinhado à direita

    // Adicionar informações gerais em 4 colunas
    const startY = 40; // Posição Y inicial
    const col1X = 10; // Posição X da primeira coluna
    const col2X = 80; // Posição X da segunda coluna
    const col3X = 150; // Posição X da terceira coluna
    const col4X = 220; // Posição X da quarta coluna

    // Primeira linha (títulos)
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Navio:", col1X, startY);
    doc.text("Viagem:", col2X, startY);
    doc.text("Local Atracação:", col3X, startY);
    doc.text("Data Atracação:", col4X, startY);

    // Segunda linha (respostas)
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(nomeNavio, col1X, startY + 10); // Resposta da coluna 1
    doc.text(rap, col2X, startY + 10); // Resposta da coluna 2
    doc.text(nomeBerco, col3X, startY + 10); // Resposta da coluna 3
    doc.text(moment(eta).format('DD/MM/YYYY'), col4X, startY + 10); // Resposta da coluna 4

    // Cabeçalho da tabela
    const head = [
        ["MERCADORIA", "PORTO", "PAÍS", "IMPORTADOR", "DI", "BL", "MANIFEST. (TON)", "APURADOR (TON)", "F/A", "F/A (TON)", "F/A (%)"]
    ];

    // Dados da tabela para o PDF
    const data = cargaData.map((item) => {
        const qtdeManifestadaTons = item.QTDE_MANIFESTADA / 1000;
        const descarregadoTons = item.DESCARREGADOH / 1000;

        const faTons = isNaN(descarregadoTons - qtdeManifestadaTons) 
            ? 'N/A' 
            : (descarregadoTons - qtdeManifestadaTons).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });

        const faPercents = isNaN((descarregadoTons - qtdeManifestadaTons) / qtdeManifestadaTons * 100)
            ? 'N/A'
            : ((descarregadoTons - qtdeManifestadaTons) / qtdeManifestadaTons * 100).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });

        return [
            item.PRODUTO,
            item.PENTAGRAMA,
            item.NOME_PAIS,
            `${item.NOME_REDUZIDO} (${formatCNPJ(item.CNPJ_CLIENTE)})`,
            item.NUMERO_DOC,
            item.BL_NUMERO,
            `${qtdeManifestadaTons.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`,
            `${descarregadoTons.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`,
            descarregadoTons < qtdeManifestadaTons ? "F" : "A",
            `${faTons}`,
            `${faPercents} %`
        ];
    });

    // Adicionar linha de totais
    const totalManifestado = cargaData.reduce((acc, item) => acc + item.QTDE_MANIFESTADA / 1000, 0);
    const totalApurado = cargaData.reduce((acc, item) => acc + item.DESCARREGADOH / 1000, 0);
    const totalFATons = cargaData.reduce((acc, item) => acc + ((item.DESCARREGADOH / 1000) - (item.QTDE_MANIFESTADA / 1000)), 0);
    const totalFAPercent = cargaData.length > 0
        ? cargaData.reduce((acc, item) => acc + ((item.DESCARREGADOH / 1000 - item.QTDE_MANIFESTADA / 1000) / (item.QTDE_MANIFESTADA / 1000) * 100), 0) / cargaData.length
        : 0;

    const totalsRow = [
        "TOTAL",
        "",
        "",
        "",
        "",
        "",
        `${totalManifestado.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`,
        `${totalApurado.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`,
        "",
        `${totalFATons.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`,
        `${totalFAPercent.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}%`
    ];

    data.push(totalsRow);

    // Geração da tabela
    autoTable(doc, {
        startY: 65, // Posição inicial da tabela
        head: head,
        body: data,
        theme: 'grid',
        headStyles: {
            fillColor: [0, 29, 73],
            textColor: [255, 255, 255],
            fontSize: 10,
            halign: 'center',
        },
        bodyStyles: {
            fontSize: 9,
            halign: 'center',
            cellPadding: 4,
        },
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.1,
    });

    // Salvar o PDF
    doc.save(`Relatorio_IDFA_${nomeNavio}.pdf`);
};

    return (
        <>
            <Navbar relatorios />
            <Header />
            <Brackground />
            <Container>
                <div className={style.content}>
                    <div className={style.columnsContainer}>
                        <div className={style.column}>
                            <div className={style.logoContainer}>
                                <img src={Logo} alt="Logo" className={style.logo} />
                            </div>
                        </div>
                        <div className={style.column}>
                            <strong>IDFA -  IDENTIFICAÇÃO DE FALTAS/ACRESCIMOS</strong>
                        </div>
                        <div className={style.column}>
                            ({moment().format('DD/MM/YYYY')})
                        </div>
                    </div>

                    <div className={style.columnsContainer4}>
                        <div className={style.column4}>
                            <div><strong>NAVIO</strong></div>
                            <div>{nomeNavio}</div>
                        </div>
                        <div className={style.column4}>
                            <div><strong>VIAGEM</strong></div>
                            <div>{rap}</div>
                        </div>
                        <div className={style.column4}>
                            <div><strong>LOCAL ATRACAÇÃO</strong></div>
                            <div>{nomeBerco}</div>
                        </div>
                        <div className={style.column4}>
                            <div><strong>DATA ATRACAÇÃO</strong></div>
                            <div>{moment(eta).format('DD/MM/YYYY')}</div>
                        </div>
                    </div>

                    <div className={style.dateContainer}></div>

                    <table className={style.table}>
    <thead>
        <tr>
            <th>MERCADORIA</th>
            <th>PORTO</th>
            <th>PAÍS</th>
            <th>IMPORTADOR</th>
            <th>DI</th>
            <th>BL</th>
            <th>MANIFEST.(TON)</th>
            <th>APURADOR(TON)</th>
            <th>F/A</th>
            <th>F/A(TON)</th>
            <th>F/A(%)</th>
        </tr>
    </thead>
    <tbody>
        {cargaData.map((item, index) => {
            const qtdeManifestadaTon = item.QTDE_MANIFESTADA / 1000;
            const descarregadoTon = item.DESCARREGADOH / 1000;
            const fa = descarregadoTon < qtdeManifestadaTon ? "F" : "A";
            const faTon = (descarregadoTon - qtdeManifestadaTon).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
            const faPercent = ((descarregadoTon - qtdeManifestadaTon) / qtdeManifestadaTon * 100).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });

            return (
                <tr key={index}>
                    <td>{item.PRODUTO}</td>
                    <td>{item.PENTAGRAMA}</td>
                    <td>{item.NOME_PAIS}</td>
                    <td>{item.NOME_REDUZIDO}</td>
                    <td>{item.NUMERO_DOC}</td>
                    <td>{item.BL_NUMERO}</td>
                    <td>{qtdeManifestadaTon.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</td>
                    <td>{descarregadoTon.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</td>
                    <td>{fa}</td>
                    <td>{faTon}</td>
                    <td>{faPercent} %</td>
                </tr>
            );
        })}
    </tbody>
    <tfoot>
        <tr>
            <td colSpan="6" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
            <td>
                {cargaData.reduce((acc, item) => acc + item.QTDE_MANIFESTADA / 1000, 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}
            </td>
            <td>
                {cargaData.reduce((acc, item) => acc + item.DESCARREGADOH / 1000, 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}
            </td>
            <td>—</td>
            <td>
                {cargaData.reduce((acc, item) => acc + ((item.DESCARREGADOH / 1000) - (item.QTDE_MANIFESTADA / 1000)), 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}
            </td>
            <td>
                {(
                    cargaData.reduce((acc, item) => acc + ((item.DESCARREGADOH / 1000 - item.QTDE_MANIFESTADA / 1000) / (item.QTDE_MANIFESTADA / 1000) * 100), 0) / cargaData.length
                ).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}%
            </td>
        </tr>
    </tfoot>
</table>
                    <button onClick={exportToPDF} className={style.exportButton}>Exportar PDF</button>
                </div>
            </Container>
        </>
    );
};

export default function IntegrationNotistack() {
    return (
        <SnackbarProvider
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            maxSnack={3}
            autoHideDuration={2500}>
            <IDFA />
        </SnackbarProvider >
    );
}
